import React from 'react';
import {
    FormControl,
    FormHeader,
    FormLabel,
    FormElement,
    Input,
    FormHelperText,
    InputSuffix,
    InputGroup,
    useFormState,
} from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { ProfileSetupSchema } from '../ProfileSetupStep.constants';
import { appTranslate } from '../../../i18n';
import { getInputSuffixIcon } from '../../../shared/utils/getInputSuffixIcon';
import { USERNAME_MAX_LENGTH, CHOOSE_WISELY_COPY_KEY } from './UsernameInput.constants';

interface Props {
    loading: boolean;
    onChange: (value: string) => void;
    success: boolean;
}

export const UsernameInput = ({ loading, onChange, success }: Props) => {
    const { isValidating, errors } = useFormState<ProfileSetupSchema>({ name: 'username' });

    const icon = getInputSuffixIcon({
        loading: isValidating || loading,
        error: Boolean(errors.username),
        success,
    });

    return (
        <FormControl name="username">
            <FormHeader>
                <FormLabel htmlFor="username">
                    <Typography fontWeight="semibold">{appTranslate('fields.username.label')}</Typography>
                </FormLabel>
            </FormHeader>
            <FormElement>
                <InputGroup onChange={(event) => onChange(event.target.value)}>
                    <Input
                        maxLength={USERNAME_MAX_LENGTH}
                        autoFocus
                        id="username"
                        placeholder={appTranslate<string>('fields.username.placeholder')}
                    />
                    <InputSuffix>{icon}</InputSuffix>
                </InputGroup>
            </FormElement>
            <FormHelperText
                hint={
                    <>
                        <Container
                            display={{
                                default: 'none',
                                md: 'block',
                            }}
                            as="span"
                        >
                            {appTranslate('fields.username.hint')}
                        </Container>
                        <Container
                            display={{
                                default: 'block',
                                md: 'none',
                            }}
                            as="span"
                        >
                            {appTranslate(CHOOSE_WISELY_COPY_KEY)}
                        </Container>
                    </>
                }
            />
        </FormControl>
    );
};
